import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { stockSearchDetail } from "../../api/GetJewellery";
import { useFilters } from "../../context/FilterContext";
import PriceValue from "../../components/Common/PriceValue";
import { Tooltip } from "primereact/tooltip";
import { Image } from 'primereact/image';
import { Skeleton } from 'primereact/skeleton';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { useCount } from "../../context/CountContext";
import { useAuth } from "../../context/AuthContext";
import { AddToCart } from "../../api/cartService";
import CommonPopUpModal from "../../components/Common/CommonPopUpModal";
import EnquiryModal from "../Enquiry/EnquiryModal";
import CustomerSelection from "../../components/Common/CustomerSelection";
import { GetMyCart } from "../../api/cartService";
import "../../css/VaultAccess/vault_access_layout.css";

export default function VaultAccessDetail() {
    document.title = "Live Inventory Detail | Meera Jewellery House Admin";

    const { markProductInEnquiry, markProductInCart } = useFilters();
    const params = useParams();
    const { style_ID } = useParams();
    const [product, setProduct] = useState(null);
    const [materials, setMaterials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modalImageIndex, setModalImageIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [collectionDetail, setCollectionDetail] = useState([]);
    const [addingToCart, setAddingToCart] = useState(false);
    const [isInCart, setisInCart] = useState(false);
    const [isInEnquiry, setisInEnquiry] = useState(false);
    const { user, customerList, switchCustomer, showToast } = useAuth();
    const [addingProductId, setAddingProductId] = useState(null);
    const [toasts, setToasts] = useState([]);
    const [tooltipOpen, setTooltipOpen] = useState({});
    const {
        fetchCartCount,
        enquiryItems,
        setEnquiryItems,
        enquiryRemark,
        setEnquiryRemark,
        isEnquiryOpen,
        setIsEnquiryOpen,
        submittingEnquiry,
        addToEnquiry,
        submitEnquiry: submitEnquiryGlobal
    } = useCount();

    const resetEnquiryState = () => {
        setIsEnquiryOpen(false);
    };
    const [copied, setCopied] = useState(false);
    const [isCommonModalOpen, setIsCommonModalOpen] = useState(false);
    const [commonModalMessage, setCommonModalMessage] = useState("");
    const [commonModalPageType, setCommonModalPageType] = useState("");
    const [commonModalTitle, setCommonModalTitle] = useState("");
    const [loadedImages, setLoadedImages] = useState({});
    const isSkeletonLoading = !product;

    const isInvalid = (val) => val === null || val === undefined || val === "" || Number(val) === 0;

    const isValidEnquiryNo = (val) => {
        if (!val) return false;
        return /^[A-Z]{1,5}\/\d{1,4}\/\d{1,4}$/i.test(val);
    };

    const formatPcsCts = (pcs, wt) => {
        return isInvalid(pcs) || isInvalid(wt) ? "-" : `${pcs} Pcs / ${wt} Cts`;
    };

    const openModal = (index) => {
        setModalImageIndex(index);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const nextImage = () => {
        setModalImageIndex((prev) => prev === product.images.length - 1 ? 0 : prev + 1);
    };

    const prevImage = () => {
        setModalImageIndex((prev) => prev === 0 ? product.images.length - 1 : prev - 1);
    };

    const showValue = (value) => {
        if (
            value === null ||
            value === undefined ||
            value === "" ||
            Number(value) === 0
        ) {
            return null;
        }
        return value;
    };

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const style_ID_from_query = queryParams.get("style_ID") || queryParams.get("Style_ID");
    const effectiveStyleID = style_ID || style_ID_from_query;

    const fetchProductDetailData = async () => {
        try {
            if (!effectiveStyleID) {
                console.warn("No style_ID found in params or query");
                return;
            }

            setLoading(true);
            setError(null);

            const payload = {
                Party_ID: String(user?.SelectedCustomer_ID || "0"),
                Style_ID: String(effectiveStyleID),
                StockCategory: "STOCK",
                PageNo: "1",
                PageSize: "50",
            };

            const response = await stockSearchDetail(payload);
            const apiData = response?.data ?? response;

            // Robust extraction of products list
            let productsList = [];
            if (apiData?.Products && Array.isArray(apiData.Products)) {
                productsList = apiData.Products;
            } else if (apiData?.ROW && Array.isArray(apiData.ROW)) {
                productsList = apiData.ROW;
            } else if (Array.isArray(apiData)) {
                productsList = apiData;
            } else if (apiData && typeof apiData === 'object' && apiData.Style_ID) {
                // If apiData itself is the product object
                productsList = [apiData];
            }

            if (productsList.length === 0) {
                console.warn("API returned empty products list for payload:", payload);
                throw new Error("Product not found");
            }

            const productItem = productsList[0];
            const materialsList = apiData?.MaterialDetail ?? apiData?.ROW1 ?? [];
            const collectionsList = apiData?.CollectionDetail ?? apiData?.ROW2 ?? [];

            const mappedProduct = {
                Shortdescription: productItem.Shortdescription,
                Style_ID: productItem.Style_ID,
                Status: productItem.Status,
                StockType: productItem.StockType,
                MetalQuality: productItem.MetalQuality,
                MetalTone: productItem.MetalTone,
                ItemSize: productItem.ItemSize,
                StoneQuality: productItem.StoneQuality,
                JewelCode: productItem.JewelCode,
                StyleNo: productItem.StyleNo,
                Category: productItem.Category,
                HallmarkNo: productItem.HallmarkNo,
                CertificateNo: productItem.CertificateNo,
                GrossWt: productItem.GrossWt,
                TotalNetWt: productItem.TotalNetWt,
                DiaWt: productItem.DiaWt,
                DiaPcs: productItem.DiaPcs,
                CDiaWt: productItem.CDiaWt,
                CDiaPcs: productItem.CDiaPcs,
                NewArrivalStatus: productItem.NewArrivalStatus,
                PriceRemark: productItem.PriceRemark,
                LineAmount: productItem.LineAmount,
                LineDiscount: productItem.LineDiscount,
                images: [
                    productItem.Image1 || "/assets/images/VaultAccess/no-image3.png",
                    productItem.Image2 || "/assets/images/VaultAccess/no-image3.png",
                    productItem.Image3 || "/assets/images/VaultAccess/no-image3.png",
                    productItem.Image4 || "/assets/images/VaultAccess/no-image3.png",
                ].filter(Boolean),
            };

            const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());
            let isInCartFinal = isTrue(productItem.IS_AddedInCart);
            let isInEnquiryFinal = isTrue(productItem.IS_AddedInEnquiry);

            // Double check with local enquiry items
            if (!isInEnquiryFinal && enquiryItems.some(p => p.Style_ID === productItem.Style_ID)) {
                isInEnquiryFinal = true;
            }

            // Double check with backend cart
            if (!isInCartFinal && user?.SelectedCustomer_ID) {
                try {
                    const cartRes = await GetMyCart({
                        Customer_ID: user?.SelectedCustomer_ID,
                        StockCategory: "STOCK",
                        BasketType: "STOCK"
                    });
                    const cartItems = cartRes?.CartItems || cartRes?.ROW || [];
                    const existingItem = cartItems.find(item => String(item.Style_ID) === String(productItem.Style_ID));
                    if (existingItem) {
                        isInCartFinal = true;
                        productItem.IS_AddedInCart = "YES";
                        productItem.Cart_ID = existingItem.Basket_ID || existingItem.Cart_ID;
                    }
                } catch (cartErr) {
                    console.error("Error fetching cart for verification:", cartErr);
                }
            }

            setisInCart(isInCartFinal);
            setisInEnquiry(isInEnquiryFinal);
            setProduct(productItem);
            const materialDetails = materialsList[0] || {};
            const collectionDetail = collectionsList || [];

            setCollectionDetail(collectionDetail);
            setProduct(mappedProduct);
            setMaterials(materialDetails);
            addToRecentViews(mappedProduct);
        } catch (err) {
            console.error("Product detail error:", err);
            showToast({
                title: "Error!",
                message: err.message || "Failed to load product details",
                type: "error",
            });
            setProduct(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (effectiveStyleID) {
            fetchProductDetailData();
        }
    }, [effectiveStyleID, user?.SelectedCustomer_ID]);

    useEffect(() => {
        document.title = product ? `${product.Shortdescription} - Live Inventory` : "Product Details";
    }, [product]);

    useEffect(() => {
        document.body.style.overflow = showModal ? "hidden" : "";
    }, [showModal]);

    const addToRecentViews = (product) => {
        let recent = JSON.parse(localStorage.getItem("recentViews")) || [];
        recent = recent.filter((p) => p.style_ID !== product.style_ID);
        recent.unshift(product);
        localStorage.setItem("recentViews", JSON.stringify(recent.slice(0, 8)));
    };
    //if (!loading && (error || !product)) {
    //    return (
    //        <VaultEmptyState
    //            title="Live Inventory Detail Not Found"
    //            description="Live Inventory details are currently unavailable.
    //                         This information may be temporarily inaccessible.
    //                         Please check back after some time or explore other designs available in Live Inventory."
    //            showButton={true}
    //        />
    //    );
    //}

    const removeEnquiryItem = (productId) => {
        setEnquiryItems(prev => prev.filter(p => p.Style_ID !== productId));
    };

    const copyEnquiryNo = () => {
        if (!isValidEnquiryNo(commonModalTitle)) return;
        navigator.clipboard.writeText(commonModalTitle).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
    };

    const submitEnquiry = async () => {
        const res = await submitEnquiryGlobal(user?.SelectedCustomer_ID, markProductInEnquiry);
        if (res.success) {
            setisInEnquiry(true);
        } else if (res.message) {
            setCommonModalTitle("Error");
            setCommonModalMessage(res.message);
            setIsCommonModalOpen(true);
        }
    };

    const handleAddToCart = async (product) => {
        if (!user?.SelectedCustomer_ID || user?.SelectedCustomer_ID === 0) {
            showToast({
                title: "Validation!",
                message: "Please select a specific customer to add items to cart.",
                type: "warning",
            });
            return;
        }
        if (!product || addingToCart) return;

        setAddingToCart(true);
        setAddingProductId(product.Style_ID);
        try {
            const payload = {
                Party_ID: user?.SelectedCustomer_ID || "0",
                Style_ID: product.Style_ID,
                JewelCode: product.JewelCode,
                StyleNo: product.StyleNo,
                Quantity: "1",
            };
            const res = await AddToCart(payload);
            const messageObj = res?.ZMESSAGE?.[0];
            if (messageObj?.RETURNCODE === "1") {
                showToast({
                    title: "Success!",
                    message: messageObj?.RETURNMESSAGE || "Product added to cart",
                    type: "success",
                });
                if (typeof markProductInCart === 'function') {
                    markProductInCart(product.Style_ID);
                }
                fetchCartCount(user?.SelectedCustomer_ID);
                setisInCart(true);
            } else {
                showToast({
                    title: "Error!",
                    message: messageObj?.RETURNMESSAGE || "Failed to add product",
                    type: "error",
                });
            }
        } catch (error) {
            console.error("Add to cart error:", error);
            showToast({
                title: "Error!",
                message: "Something went wrong while adding to cart",
                type: "error",
            });
        } finally {
            setAddingToCart(false);
            setAddingProductId(null);
        }
    };

    const handleImageLoad = (index) => {
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    };

    const handleImageError = (e, index) => {
        e.currentTarget.src = "/assets/images/vaultaccess/no-image3.png";
        setLoadedImages(prev => ({ ...prev, [index]: true }));
    };

    return (
        <>
            <section className="vault-header-detail-card">
                <div className="product-detail-header-left">
                    <h3 className="page-title">Live Inventory Detail</h3>
                </div>
                <div className="product-detail-header-right">
                    <div className="customer-wrapper">
                        <CustomerSelection />
                    </div>
                    <button className="back-btn" onClick={() => window.history.back()} aria-label="Go back">
                        <i className="pi pi-arrow-left"></i>
                    </button>
                </div>
            </section>

            <section className="Vault-access-detail vault-header-card mt-3">
                <div className="container-fluid">
                    {isSkeletonLoading ? (
                        <div className="row g-4 align-items-start">
                            <div className="col-lg-7 col-md-12">
                                <div className="row g-3">
                                    {[1, 2, 3, 4].map((i) => (
                                        <div className="col-md-6" key={i}>
                                            <div className="image-box w-100 position-relative" style={{ minHeight: '300px' }}>
                                                <Skeleton className="image-thumb img-fluid" width="100%" height="100%" borderRadius="8px" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12">
                                <div className="Product-Detail-section">
                                    <div className="product-heading">
                                        <div className="d-flex align-items-center gap-2 mb-3">
                                            <Skeleton width="70%" height="2rem" borderRadius="4px" />
                                        </div>
                                        <div className="d-flex align-items-baseline mb-2">
                                            <Skeleton width="100px" height="1.2rem" className="me-2" />
                                            <Skeleton width="150px" height="1.2rem" />
                                        </div>
                                        <div className="mt-3">
                                            <Skeleton width="120px" height="1.8rem" />
                                        </div>
                                    </div>

                                    <div className="Details-section row mt-4">
                                        <div className="product-details col-12">
                                            <Skeleton width="140px" height="1.5rem" className="mb-3" />
                                            <div className="mb-2 d-flex gap-2">
                                                <Skeleton width="100px" height="1rem" />
                                                <Skeleton width="120px" height="1rem" />
                                            </div>
                                            <div className="mb-2 d-flex gap-2">
                                                <Skeleton width="100px" height="1rem" />
                                                <Skeleton width="80px" height="1rem" />
                                            </div>
                                            <div className="mb-2 d-flex gap-2">
                                                <Skeleton width="100px" height="1rem" />
                                                <Skeleton width="90px" height="1rem" />
                                            </div>
                                        </div>
                                        <div className="diamond-details col-12 mt-4">
                                            <Skeleton width="150px" height="1.7rem" className="mb-3" />
                                            {[1, 2, 3, 4, 5].map((i) => (
                                                <div key={i} className="mb-2 d-flex gap-2">
                                                    <Skeleton width="110px" height="1rem" />
                                                    <Skeleton width="100px" height="1rem" />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="product-actions stock-detail d-flex text-center mt-4 gap-2">
                                    <Skeleton width="160px" height="40px" borderRadius="6px" />
                                    <Skeleton width="160px" height="40px" borderRadius="6px" />
                                </div>
                                <div className="py-3 bg-white category-sidebar col-12 mt-4">
                                    <Skeleton width="150px" height="1.5rem" className="mb-3" />
                                    <ul className="d-flex mb-0">
                                        {[1, 2, 3].map((i) => (
                                            <li className="mb-2 d-flex align-items-center gap-2" key={i}>
                                                <Skeleton shape="circle" size="12px" />
                                                <Skeleton width="100px" height="1rem" />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row g-4 align-items-start">
                            <div className="col-lg-7 col-md-12">
                                <div className="row g-3">
                                    {product.images.map((img, index) => (
                                        <div className="col-md-6" key={index}>
                                            <div className="" key={index}>
                                                <div className="image-box w-100 position-relative">
                                                    {!loadedImages[index] && (
                                                        <div className="skeleton-wrapper-vaultdetail">
                                                            <div className="skeleton-image-vaultdetail" />
                                                        </div>
                                                    )}

                                                    <img
                                                        src={product.images[index]}
                                                        alt={`Product ${index + 1}`}
                                                        loading="lazy"
                                                        width="100%"
                                                        className="image-thumb img-fluid"
                                                        style={{
                                                            opacity: loadedImages[index] ? 1 : 0,
                                                            transition: "opacity 0.3s ease",
                                                        }}
                                                        onLoad={() => handleImageLoad(index)}
                                                        onError={(e) => handleImageError(e, index)}
                                                    />
                                                    <button className="zoom-btn" onClick={(e) => { e.stopPropagation(); openModal(index); }}>
                                                        <i className="pi pi-search-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12">
                                <div className="Product-Detail-section">
                                    <div className="product-heading">
                                        <h3 className="fw-bold mb-3 d-flex align-items-center gap-2">
                                            <span className="product-name fw-bold">
                                                {product.Shortdescription || "Live Inventory Detail"}
                                            </span>
                                            {Number(product.Status) !== 0 && (
                                                <span className="badge badge-status badge-detail">
                                                    {String(product.Status).toUpperCase()}
                                                </span>
                                            )}

                                            {Number(product.NewArrivalStatus) !== 0 && (
                                                <span className="badge badge-new-arrival">
                                                    {String(product.NewArrivalStatus).toUpperCase()}
                                                </span>
                                            )}
                                        </h3>
                                        <div className="d-flex align-items-baseline">
                                            <h5 className="fw-bold me-1">Product Code: </h5>
                                            <span>{showValue(product.StyleNo)} /  {showValue(product.JewelCode)}</span>
                                        </div>
                                        <PriceValue
                                            lineAmount={product.LineAmount}
                                            lineDiscount={product.LineDiscount}
                                            priceRemark={product.PriceRemark}
                                        />
                                    </div>
                                    <div className="Details-section row">
                                        <div className="product-details">
                                            <h5 className="detail-heading fw-bold mt-2"> Product Details: </h5>
                                            <div className="mb-2"><b>Gold Purity:</b>{" "}{showValue(product.MetalQuality)} / {showValue(product.MetalTone)}</div>
                                            <div className="mb-2"><b>Gold Weight:</b> {showValue(product.TotalNetWt)}</div>
                                            <div className="mb-2"><b>Dimension:</b> {showValue(product.ItemSize)}</div>
                                        </div>
                                        <div className="diamond-details mt-2">
                                            <h5 className="detail-heading fw-bold"> Diamond Details: </h5>
                                            <div className="fw-bold mb-2"> Diamond Weight: <span className="fw-normal">{formatPcsCts(product.DiaPcs, product.DiaWt)}</span> </div>
                                            <div className="fw-bold mb-2"> Color Diamond: <span className="fw-normal">{formatPcsCts(product.CDiaPcs, product.CDiaWt)}</span> </div>
                                            <div className="fw-bold mb-2"> Gross Weight: <span className="fw-normal">{isInvalid(product.GrossWt) ? "-" : product.GrossWt}</span> </div>
                                            <div className="mb-2"><b>Hallmark No:</b> {showValue(product.HallmarkNo) || "-"}</div>
                                            <div className="mb-2"><b>Certificate No:</b> {showValue(product.CertificateNo) || "-"}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-actions stock-detail d-flex text-center mt-3 gap-2">
                                    <button
                                        id={`enquiry-btn-${product.Style_ID}`}
                                        type="button"
                                        className={`btn-enquire ${isInEnquiry ? "btn-outline-enquiry disabled-btn" : ""}`}
                                        onClick={() => {
                                            if (isInEnquiry) return;
                                            if (!user?.SelectedCustomer_ID || user?.SelectedCustomer_ID === 0) {
                                                showToast({
                                                    title: "Validation!",
                                                    message: "Please select a specific customer for enquiry.",
                                                    type: "warning",
                                                });
                                                return;
                                            }
                                            addToEnquiry(product);
                                        }}
                                    >
                                        {isInEnquiry ? (
                                            <span className="d-flex align-items-center justify-content-center">
                                                IN ENQUIRY
                                            </span>
                                        ) : (
                                            "ENQUIRE NOW"
                                        )}
                                    </button>

                                    {isInEnquiry && (
                                        <Tooltip
                                            target={`#enquiry-btn-${product.Style_ID}`}
                                            position="top"
                                            event="click"
                                        >
                                            This product is already added to enquiry
                                        </Tooltip>
                                    )}

                                    <button
                                        id={`cart-btn-${product.Style_ID}`}
                                        type="button"
                                        className={`btn-cart-outline ${isInCart ? "btn-outline-cart disabled-btn" : isInEnquiry ? "disabled-btn" : ""}`}
                                        onClick={() => {
                                            if (isInCart || isInEnquiry || addingToCart) return;
                                            handleAddToCart(product);
                                        }}
                                    >
                                        {isInCart ? (
                                            <span className="d-flex align-items-center justify-content-center">
                                                IN CART
                                            </span>
                                        ) : (
                                            "ADD TO CART"
                                        )}
                                    </button>

                                    {(isInCart || isInEnquiry) && (
                                        <Tooltip
                                            target={`#cart-btn-${product.Style_ID}`}
                                            position="top"
                                            event="click"
                                        >
                                            {isInCart
                                                ? "This product is already in your cart"
                                                : "Products in enquiry can’t be added to cart"}
                                        </Tooltip>
                                    )}
                                </div>
                                <div className="py-3 bg-white category-sidebar col-12">
                                    <h4 className="detail-heading fw-bold">Collection Details</h4>
                                    <ul className="list-unstyled mb-0 blog-list">
                                        {collectionDetail.map((collection, i) => (
                                            <li className="mb-2" key={i}>
                                                <p className={`small collection-item mb-0 d-flex align-items-center gap-2 ${collection.ISBaseCollection? "fw-bold base-collection" : ""}`}>
                                                    <i className="pi pi-circle-fill fs-6 d-flex align-items-center justify-content-center"></i>
                                                    <span>{collection.Collection}</span>
                                                    {collection.ISBaseCollection && (
                                                        <span className="base-collection-hover"> Base Collection </span>
                                                    )}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    )}
                    {showModal && (
                        <div className="fullscreen-modal" onClick={closeModal}>
                            <button className="modal-close-btn" onClick={closeModal} aria-label="Close">
                                <i className="pi pi-times"></i>
                            </button>
                            <div className="modal-image-wrapper" onClick={(e) => e.stopPropagation()}>
                                <Image
                                    src={product.images?.[modalImageIndex] || "/assets/images/VaultAccess/no-image.png"}
                                    zoomSrc={product.images[modalImageIndex]}
                                    zoomType="click"
                                    moveType="drag"
                                    zoomScale={2}
                                    hasSpacer={false}
                                    onError={(e) => {
                                        e.target.src = "/assets/images/VaultAccess/no-image.png";
                                    }}
                                />
                            </div>
                            <div className="modal-pagination" onClick={(e) => e.stopPropagation()}>
                                <button onClick={prevImage}>
                                    ‹
                                </button>

                                <span> {modalImageIndex + 1} / {product.images.length} </span>

                                <button onClick={nextImage}>
                                    ›
                                </button>
                            </div>
                        </div>
                    )}
                    {/*<SimilarProductsSlider*/}
                    {/*    currentProductId={style_ID}*/}
                    {/*    category={product.category}*/}
                    {/*/>*/}
                    {/*<RecentViewedSlider />*/}
                </div>
            </section>

            <CommonPopUpModal
                isOpen={isCommonModalOpen}
                onClose={() => setIsCommonModalOpen(false)}
                message={commonModalMessage}
                pageType={commonModalPageType}
                title={
                    commonModalPageType === "enquiry" ? (
                        <>
                            <div className="popup-subtitle">
                                Thanks for reaching out to us.
                            </div>

                            <div className="popup-enquiry-label">
                                Your Enquiry No is
                            </div>

                            <div
                                className={`popup-enquiry-no ${isValidEnquiryNo(commonModalTitle) ? "copyable" : ""}`}
                                onClick={copyEnquiryNo}
                                title={isValidEnquiryNo(commonModalTitle) ? "Click to copy" : ""}
                            >
                                <span>{commonModalTitle}</span>

                                {isValidEnquiryNo(commonModalTitle) && (
                                    <span className={`copy-wrapper ${copied ? "copied" : ""}`}>
                                        <i className="pi pi-copy copy-icon" />
                                        {copied && (
                                            <span className="copied-tooltip">
                                                Copied!
                                            </span>
                                        )}
                                    </span>
                                )}
                            </div>
                        </>
                    ) : (
                        commonModalTitle
                    )
                }
            />

            <EnquiryModal
                isOpen={isEnquiryOpen}
                toggle={resetEnquiryState}
                items={enquiryItems}
                remark={enquiryRemark}
                setRemark={setEnquiryRemark}
                onRemoveItem={removeEnquiryItem}
                onSubmit={submitEnquiry}
                submitting={submittingEnquiry}
                title="Product Enquiry"
            />
        </>
    );
}
//<CommonToastContainer toasts={toasts} removeToast={removeToast} />
/*  <CommonPopUpModal
    isOpen={isCommonModalOpen}
    onClose={() => setIsCommonModalOpen(false)}
    message={commonModalMessage}
    pageType={commonModalPageType}
    title={
        commonModalPageType === "enquiry" ? (
            <>
                <div className="popup-subtitle">
                    Thanks for reaching out to us.
                </div>

                <div className="popup-enquiry-label">
                    Your Enquiry No is
                </div>

                <div
                    className={`popup-enquiry-no ${isValidEnquiryNo(commonModalTitle) ? "copyable" : ""
                        }`}
                    onClick={copyEnquiryNo}
                    title={
                        isValidEnquiryNo(commonModalTitle)
                            ? "Click to copy"
                            : ""
                    }
                >
                    <span>{commonModalTitle}</span>

                    {isValidEnquiryNo(commonModalTitle) && (
                        <span className={`copy-wrapper ${copied ? "copied" : ""}`}>
                            <i className="bx bx-copy copy-icon" />
                            {copied && (
                                <span className="copied-tooltip">
                                    Copied!
                                </span>
                            )}
                        </span>
                    )}
                </div>
            </>
        ) : (
            commonModalTitle
        )
    }
/>*/

//<EnquiryModal
//    isOpen={isEnquiryOpen}
//    toggle={resetEnquiryState}
//    items={EnquiryItems}
//    remark={EnquiryRemark}
//    setRemark={setEnquiryRemark}
//    onRemoveItem={removeEnquiryItem}
//    onSubmit={submitEnquiry}
//    submitting={submittingEnquiry}
//    title="Product Enquiry"
///>